<template>
  <div class="ui middle aligned grid h-full" id="login">
    <div class="column login mx-auto">
      <div class="ui segment">
        <div class="mt-2 mb-10 text-center text-xl text-gray-700 font-bold">
          注册红豆云
        </div>
        <div v-if="step==-1" class="ui form">
          <div class="field">
            {{ this.error }}
          </div>
          <a class="ui fluid large teal button" href="/">返回</a>
        </div>
        <div v-if="step==1" class="ui form mobile">
          <div class="field">
            <div class="ui left icon input">
              <i class="mobile alternate icon"></i>
              <input name="mobile" type="text" maxlength="16" v-model="mobile" id="mobile" placeholder="请输入手机号码开始注册">
            </div>
          </div>
          <div class="text-left field">
            <div class="ui toggle checkbox">
              <input id="keep-login" name="keep-login" type="checkbox" tabindex="0" v-model="agree">
              <label>
                我同意
                <a @click.stop="show_agreement" class="text-blue-500">红豆云服务协议</a>
                和
                <a @click.stop="show_privacy" class="text-blue-500">用户隐私协议</a>
              </label>
            </div>
          </div>
          <button @click="send_sms(false)" id="send-sms" class="ui fluid large teal button">
            发送验证码
            (是的，我同意上述协议!)
          </button>
          <AgreementModal id="agreement" kind='user'/>
          <AgreementModal id="privacy" kind='privacy'/>
        </div>
        <div v-if="step==2" class="ui form sms">
          <p class="text-left ui message">短信已发送至{{ mobile }}</p>
          <div class="field text-left">
            <input name="sms_code" maxlength="10" type="text" v-model="sms_code" id="sms_code" placeholder="请输入收到的验证码"/>
            <div class="mt-2">
              <button class="ui button" @click="resend_sms" :disabled="cool_down > 0" id="resend_sms">
                重新发送
                <span v-if="cool_down"> ({{ cool_down }})</span>
              </button>
            </div>
          </div>
          <button class="ui fluid teal button" id="submit_sms" @click="check_sms">提交</button>
        </div>
        <div v-if="step==3" class="ui form email">
          <div class="field text-left">
            <p>输入电子邮箱完成注册</p>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="mail icon"></i>
              <input name="email" maxlength="128" type="email" id="email" v-model="email" placeholder="请输入邮箱地址">
            </div>
          </div>
          <button class="ui fluid teal button" @click="register" id="submit_email">提交</button>
        </div>
        <div v-if="step==4" class="ui message done">
          注册验证邮件已发送到<span class="font-bold text-green-500 mx-1">{{ email }}</span>，请点击邮件中的链接激活账号。
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import AgreementModal from '../components/agreement.vue'

export default {
  name: '',
  props: [],
  components: {
    AgreementModal,
  },
  data: function () {
    return {
      subscribed: false,
      busy: false,
      step: 1,
      email: "",
      mobile: "",
      sms_code: "",
      cool_down: 0,
      counter: null,
      error: "",
      agree: true,
    };
  },
  computed: {
    mobile_valid() {
      return this.mobile.match(/^1[3-9][0-9]{9}$/);
    },
    sms_code_valid() {
      return this.sms_code.match(/^[0-9]{7}$/);
    },
    email_valid() {
      return this.email.match(/^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/);
    },
  },
  methods: {
    subscribe() {
      if (this.email.length == 0) {
        return;
      }
      this.$gtag.event('landing-subscribe', {
        event_category: 'user-action',
      });
      this.subscribed = true;
      this.$store.state.client.subscribe(this.email);
    },
    error_message(rt) {
      switch (rt) {
        case "EEXIST":
          return "用户已存在";
        case "EBUSY":
          return "请稍后再重试";
        default:
          return rt;
      }
    },
    check_response(r, keep_step=false) {
      this.busy = true;
      r.then(() => {
        if (!keep_step) this.step++;
        this.$gtag.pageview({
          page_path: '/register/step-' + this.step,
        });
        this.busy = false;
      }).catch(e => {
        this.show_error(this.error_message(e.response.data));
        this.busy = false;
      });
    },
    show_agreement() {
      this.show_modal('agreement');
    },
    show_privacy() {
      this.show_modal('privacy');
    },
    send_sms(resend=false) {
      if (!this.agree) {
        this.show_error("请先同意用户协议");
        return;
      }
      if (!this.mobile_valid) {
        this.show_error("请输入正确的手机号码");
        return;
      }
      this.cool_down = 60;
      if (this.counter) {
        clearInterval(this.counter);
      }
      this.counter = setInterval(() => {
        if (--this.cool_down == 0) {
          clearInterval(this.counter);
        }
      }, 1000);
      this.check_response(this.client.mobile_send_token(this.mobile), resend);
    },
    resend_sms() {
      this.send_sms(true);
    },
    check_sms() {
      if (!this.sms_code_valid) {
        this.show_error("验证码无效");
        return;
      }
      this.check_response(this.client.check_sms(this.mobile, this.sms_code));
    },
    register() {
      if (!this.email_valid) {
        this.show_error("电子邮件输入有误");
        return;
      }
      this.check_response(this.client.register(this.mobile, this.sms_code, this.email));
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
.reg h5 {
  margin-bottom: 50px;
}
.footer {
  margin-top: 200px;
}
</style>
